var render, staticRenderFns
import script from "./LogoList.vue?vue&type=script&lang=js&"
export * from "./LogoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2149c5a9')) {
      api.createRecord('2149c5a9', component.options)
    } else {
      api.reload('2149c5a9', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Logo/resources/vue/LogoList.vue"
export default component.exports